import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectLoanActionArithmeticOperationsSchema = createSelector(
  getSystem,
  ({ loanActionArithmeticOperationsSchema }) => loanActionArithmeticOperationsSchema,
);
